import type { FacetCount } from "@/pages/areas/lib/area-hits";
import { parseCityKey } from "@/types/area";

export interface CityOption {
  city: string;
  countryCode: string;
}

/** The cities of a `cityKey` facet, as the exact `city` + `countryCode` pairs in the data, sorted. */
export const citiesFromFacet = (counts: readonly FacetCount[]): CityOption[] =>
  counts
    .map((c) => parseCityKey(c.value))
    .sort(
      (a, b) =>
        a.city.localeCompare(b.city) ||
        a.countryCode.localeCompare(b.countryCode),
    );
